import { TextField, Stack, SxProps, Theme } from '@mui/material';
import { CPFormHelperText } from './CPFormHelperText';
import { capitalize } from '@warden-ui/common';

interface CPTextFieldProps {
  id: string;
  label: string;
  value: string;
  type?: string;
  autoFocus?: boolean;
  errorMessage?: string;
  capitalizeFirstLetterOnly?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
  onChange?: (val: string) => void;
  inputProps?: any;
  sx?: SxProps<Theme>;
}

export const CPTextField = ({
  id,
  label,
  value,
  type = 'text',
  autoFocus = true,
  capitalizeFirstLetterOnly = false,
  variant = 'outlined',
  errorMessage = '',
  onChange = () => {},
  // by default, disable autocomplete (https://stackoverflow.com/a/56224685)
  inputProps = { form: { autocomplete: 'off' } },
  ...props
}: CPTextFieldProps) => {
  const hasErrorMessage = errorMessage.length > 0;

  return (
    <Stack spacing={0.5} sx={props.sx} className='w-100'>
      <TextField
        id={id}
        label={capitalize(label, capitalizeFirstLetterOnly)}
        variant={variant}
        value={value}
        type={type}
        autoFocus={autoFocus}
        onChange={(e) => onChange(e.target.value)}
        aria-describedby={`${id}-helper`}
        color={hasErrorMessage ? 'error' : 'primary'}
        error={hasErrorMessage}
        InputProps={inputProps}
      />

      <CPFormHelperText
        id={`${id}-helper`}
        message={errorMessage}
        error={hasErrorMessage}
      />
    </Stack>
  );
};